/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

/**
 * RecipientStatusBadge's "Resend link" icon: a clockwise arrow, as in the
 * client's status design (https://prnt.sc/F_usrM0hB1M2). It used to reuse
 * AttachmentRetryIcon's glyph, whose arrow turns anticlockwise — "the
 * direction of the arrow is wrong" (client, 2026-09-23 Discord).
 * Colour comes from `fill`, like the other status icons.
 */
function RetryLinkIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.fill || props.stroke || '#1A92FF';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M21 3v5h-5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export default RetryLinkIcon;
